// extracted by mini-css-extract-plugin
module.exports = {"ProfileDisplay":"ProfileDisplay_ProfileDisplay__1yyog","ImageContainer":"ProfileDisplay_ImageContainer__2I0Uc","ProfileImage":"ProfileDisplay_ProfileImage__RMcpX"};